import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";

type BackButtonProps = {
  className?: string;
  /** Override default navigate(-1); e.g. for not-found states */
  onClick?: () => void;
};

export function BackButton({ className, onClick }: BackButtonProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      void navigate(-1);
    }
  };

  return (
    <Button
      icon="pi pi-arrow-left"
      label="Back"
      className={`p-button-text flex-shrink-0 ${className ?? ""}`.trim()}
      onClick={handleClick}
      aria-label="Back"
    />
  );
}
